import { Theme } from '@mui/material';

export const getExpiredBgColor = (theme: Theme): string | undefined =>
	theme.palette.mode === 'dark' ? theme.palette.dustred[50] : theme.palette.error.lighter;
